"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dark_theme_1 = __importDefault(require("../../global/dark-theme"));
var PointOfInterest_1 = __importDefault(require("../icons/generated/PointOfInterest"));
var PointOfInterestPin = function () {
    return react_1.default.createElement(PointOfInterest_1.default, { style: { width: '24px' }, fill: dark_theme_1.default.colours.map.pointOfInterest });
};
PointOfInterestPin.displayName = 'PointOfInterestPin';
exports.default = PointOfInterestPin;
